import { useMutation } from "@tanstack/react-query";
import apiSetting from "../services/setting";

export function useBillPaymentMutation() {
  const sendBillSlip = useMutation({
    mutationFn: (data) => apiSetting.SendBillSlipContract( data ),
  });

  const sendOmise = useMutation({
    mutationFn: (data) => apiSetting.SendOmise( data ),
  });


  return { 
    sendBillSlip,
    sendOmise,

};
}